import { Section } from "@/components/ui/Section";
import { Col } from "@/components";
import { LoginBanner } from "@/components/ui/LoginBanner";
import "../Login/Login.scss";

export type LoginOperatorEntry = {
  href: string;
  label: React.ReactNode;
  ariaLabel?: string;
  showIcon?: boolean;
  icon?: React.ReactNode;
  asLink?: "a" | React.ComponentType<any>;
};

export type LoginOperatorProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  loginTitle: React.ReactNode;
  loginDescription?: React.ReactNode;
  entries: LoginOperatorEntry[];
  rightDescription?: React.ReactNode;
  rightContent: React.ReactNode;
  entryButtonAsLink?: "a" | React.ComponentType<any>;
  bannerClassName?: string;
};

export const LoginOperator = ({
  title,
  description,
  loginTitle,
  loginDescription,
  entries,
  rightDescription,
  rightContent,
  entryButtonAsLink = "a",
  bannerClassName,
}: LoginOperatorProps) => {
  return (
    <Section className="base-col ui-login-section">
      <Col className="ui-login-content">
        <Section.Title fs="1" className="md-fs-0 ui-login-title" mdFs="0">
          {title}
        </Section.Title>
        {description && (
          <Section.Description className="ui-login-description">
            {description}
          </Section.Description>
        )}
      </Col>
      <LoginBanner
        title={loginTitle}
        description={loginDescription}
        entries={entries}
        rightDescription={rightDescription}
        rightContent={rightContent}
        entryButtonAsLink={entryButtonAsLink}
        className={bannerClassName}
      />
    </Section>
  );
};
